module.exports = __webpack_public_path__ + "img/banner1-dialog.cf2bd3e5.png";